import { createArrayByUniqueKeySelectorFamily, createFieldSelectorFamily, } from '@zurich/common/recoil';
import { productsSelector } from '../root';
export const productSelectorFamily = createArrayByUniqueKeySelectorFamily(productsSelector, 'productName', { defaultValue: {} });
export const productHelper = createFieldSelectorFamily(productSelectorFamily);
export const productFeaturesSelectorFamily = productHelper('productFeatures', {
    defaultValue: [],
});
